import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
// import {SESSION_DATA, user,} from "../../constants";
// import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CiSquarePlus } from "react-icons/ci";
import { FaPlus } from "react-icons/fa";
import { use } from "react";


const AddEditLocation = () => {

    const navigate = useNavigate();
    const [specializationCount, setSpecializationCount] = useState([0,1,2,3,4,5,6,7,8]);
    const [stateDistInfo, setStateDistInfo] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const { id } = useParams();
    const [addUpdate, setAddUpdate] = useState(false);
    const [submitForm, errorSubmit, loadingSubmit, axiosSubmit] =
    useAxios();
    const [stateDistData, errorStateDist, loadingStateDist, axiosFetchStateDist] =
    useAxios();
    const [locationData, errorLocation, loadingLocation, axiosLocation] =
    useAxios();


  const SUBMIT_FORM_DATA_URL = id && id != undefined?`master/updateLocationData/${id}`:`master/createLocationData`;
  const GET_STATE_DIST_URL = `master/getStateDistrictData`;
  const GET_LOC_URL = id && id != undefined?`master/getLocation/${id}`:"";

  const getStateData = (url) => {
    axiosFetchStateDist({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };
  useEffect(() => {
    getStateData(GET_STATE_DIST_URL);   
},[GET_STATE_DIST_URL,id]);

useEffect(() => {
    setStateDistInfo(stateDistData?.[0]?.StateDistrictsData) 
},[loadingStateDist]);

  const getLocation = (url) => {
    axiosLocation({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };

      useEffect(() => {
          const fetchStateData = async () => {
            if (!id) return;
        
            try {
              getLocation(GET_LOC_URL);
            
            } catch (error) {
              console.error("Error fetching  data:", error);
            }
          };
        
          fetchStateData();
        }, [GET_LOC_URL]);

        useEffect(() => {
          const fetchStateDataB = async () => {
            if (!id) return;
           console.log("test locationData",locationData)
            try {
              if (locationData?.length > 0) {
                setValue("state", `${locationData?.[0]?.stateId}_${locationData?.[0]?.stateName}`);
                setValue("district", `${locationData?.[0]?.districtId}_${locationData?.[0]?.districtName}`);
                setValue("locationName", locationData?.[0]?.locationName);
                setValue("address", locationData?.[0]?.address);
                setValue("pincode", locationData?.[0]?.pincode);
              } else {
                console.warn("No location data found for the given ID");
              }
            } catch (error) {
              console.error("Error fetching  data:", error);
            }
          };
          fetchStateDataB();
        }, [locationData, loadingLocation]);

        useEffect(() =>{
          if (locationData?.length > 0 && stateDistInfo) {
            const getStateId = locationData[0]?.stateId;
         if(getStateId){
           const filteredDistricts = stateDistInfo?.find(
             (item) => item._id === getStateId
           )?.districts;  
             const districtOptions = filteredDistricts?.map((district) => ({
               id: district?._id,
               districtName: district?.districtName,
             })) ?? [];
              setDistrictData( districtOptions);
          
         }
           }
          }, [stateDistInfo,locationData, loadingLocation]);

  const form = useForm({
    defaultValues: {
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;

  const { errors } = formState;

  const onFormSubmit = async (data) => {
    const toTitleCase = (str) => {
      return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
        return match.toUpperCase();
      });
    };

    let formData = {
      locationName: data.locationName,
      address: data.address,
      stateId: data.state.split("_")[0],
      stateName: data.state.split("_")[1],
      districtId: data.district.split("_")[0],
      districtName: data.district.split("_")[1],
      pincode: data.pincode,
      status: "A"
     
    };
    console.log("form data",formData);

    await axiosSubmit({
      axiosInstance: axiosInstance,
      url: SUBMIT_FORM_DATA_URL,
      method: "POST",
      requestConfig: {
        data: formData,
      },
    });

    setAddUpdate(true);
  };
  console.log("test loca data",submitForm)
  useEffect(() => {
    if (addUpdate && !submitForm?.[0]?.['success']) {
      toast.error(
        submitForm?.[0]?.['message'],
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 50,

        }
      );
      setAddUpdate(false);

    } else if (addUpdate && submitForm?.[0]?.['success']) {
      navigate(
        `/master/locationlisting`
      );
    }
  }, [loadingSubmit, errorSubmit]);

  const handleDistrict = (e) => {
    const [stateId, stateName] = e.target.value.split("_"); 
    const filteredDistricts = stateDistInfo?.find(
      (item) => item._id === stateId
    )?.districts;  
    if (filteredDistricts) {
      const districtOptions = filteredDistricts?.map((district) => ({
        id: district?._id,
        districtName: district?.districtName,
      }));
      setDistrictData( districtOptions);
    } else {
        setDistrictData([]);
    }
  };
  return (
    <>
      <div className="card min-height-100">
        <div className="card-title flex-row">
          <h2>{id ? "Edit" : "Add"} Location </h2>
          <Link to="/master/locationListing">
            <button className="btn btn-blue rounded-10">Back</button>
          </Link>
        </div>
        <ToastContainer />

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
            <div className="col-md-4  tank-col-info">
                <label htmlFor="locationName" className="text-gray text-semi-bold">
                  Location Name<span className="text-red">*</span>
                </label>
                <input
                  id="locationName"
                  {...register("locationName", {
                    required: {
                      value: true,
                      message: "Location Name Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Location name"
                />
                <p className="text-red">{errors.locationName?.message}</p>
              </div>
            <div className="col-md-4  tank-col-info">
                <label htmlFor="address" className="text-gray text-semi-bold">
                  Address<span className="text-red">*</span>
                </label>
                <input
                  id="address"
                  {...register("address", {
                    required: {
                      value: true,
                      message: "Address Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Address name"
                />
                <p className="text-red">{errors.address?.message}</p>
              </div>

              <div className="col-md-4  tank-col-info">
                    <label
                      htmlFor="state"
                      className="text-gray text-semi-bold"
                    >
                      State<span className="text-red">*</span>
                    </label>

                    <select
                      id="state"
                      {...register("state", {
                        required: {
                          value: true,
                          message: "state Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select State"
                      onChange={handleDistrict}
                    >
                      <option value="">Select State</option>
                      {stateDistInfo?.map((listFetch, index) => (
                        <option
                        key={listFetch?._id}

                          value={`${listFetch?._id}_${listFetch?.stateName}`}
                          selected ={`${locationData?.[0]?.stateId}` == `${listFetch?._id}`}
                        >
                          {listFetch?.stateName}
                        </option>
                      ))}
                    </select>

                    <p className="text-red">{errors.state?.message}</p>
                  </div>
              <div className="col-md-4  tank-col-info">
                    <label
                      htmlFor="district"
                      className="text-gray text-semi-bold"
                    >
                      District<span className="text-red">*</span>
                    </label>

                    <select
                      id="district"
                      {...register("district", {
                        required: {
                          value: true,
                          message: "District Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select District"
                      
                    >
                      <option value="">Select District</option>
                      {districtData?.map((listFetch, index) => (
                        <option
                          value={`${listFetch?.id}_${listFetch?.districtName}`}
                          selected ={`${locationData[0]?.districtId}` === `${listFetch?.id}`}

                        >
                          {listFetch?.districtName}
                        </option>
                      ))}
                    </select>

                    <p className="text-red">{errors.district?.message}</p>
                  </div>






             
            <div className="col-md-4  tank-col-info">
                <label htmlFor="pincode" className="text-gray text-semi-bold">
                Pincode<span className="text-red">*</span>
                </label>
                <input
                  id="pincode"
                  {...register("pincode", {
                    required: {
                      value: true,
                      message: "pincode Field is Required",
                    },
                    pattern: {
                        value: /^\d+$/,
                        message: "Pincode must contain only numbers",
                      },
                    
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Pincode name"
                />
                <p className="text-red">{errors.pincode?.message}</p>
              </div>
             
          
            
            
            

              <div className="col-md-12 text-center">
                <input
                  type="submit"
                  className="btn btn-red rounded-10"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>

       
      </div>
    </>
  );
};

export default AddEditLocation;
